import { useEffect } from 'react';
import { CommonLayout, ConfigLayoutVisualizations, ListViewLayout } from '../../layouts';
import { useVisualizationService } from 'services';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { currentVisualizationState, visualizationsState, newItemState, Visualization } from 'states';
import { Notify } from 'components/core';
import { useListStatus } from 'molecules/listState/useListStatus';
import { ENTITY_TYPE } from '../../../constants';
import styles from './VisualizationHome.module.css';

export const VisualizationHome = () => {
  const [visualizations, setVisualizations] = useRecoilState(visualizationsState);
  const [currentVisualization, setCurrentVisualization] = useRecoilState(currentVisualizationState);
  const visualizationService = useVisualizationService();
  const { status, track } = useListStatus();

  const isSelected  = !!currentVisualization && Object.keys(currentVisualization).length > 0;
  const setIsNewItem = useSetRecoilState(newItemState);

  useEffect(() => {
    setIsNewItem(false); // reset stale add-new state on every mount
    setCurrentVisualization({} as Visualization); // reset to list view — prevents stale open visualization showing on nav click
    getVisualizations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getVisualizations = () => {
    track(visualizationService.getAllVisualizations()).then(
      (response: any) => {
        if (response.length > 0) setVisualizations(response);
      },
      (error) => Notify.error(error)
    );
  };

  return (
    <CommonLayout>
      <div className={styles.pageArea}>
        <div className={isSelected ? styles.hidden : styles.fullWidth}>
          <ListViewLayout
            listItems={visualizations}
            showFloatingBtn={true}
            btnText="New visualization"
            itemType={ENTITY_TYPE.VISUALIZATION}
            status={status}
            onRetry={getVisualizations}
          />
        </div>

        {/* Detail panel — full width when a visualization is selected */}
        {isSelected && (
          <div className={styles.fullWidth}>
            <ConfigLayoutVisualizations />
          </div>
        )}
      </div>
    </CommonLayout>
  );
};
